/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Expense_CategoriesInputs */

const vi_nav_expense_categories = /** @type {(inputs: Nav_Expense_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh mục chi`)
};

/**

* @param {Nav_Expense_CategoriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_expense_categories = /** @type {((inputs?: Nav_Expense_CategoriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Expense_CategoriesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_expense_categories(inputs)
});